import React, { forwardRef, useMemo } from 'react'
import { Platform, StyleSheet } from 'react-native'
import { ReduceMotion } from 'react-native-reanimated'
import { BottomSheetBackdrop, BottomSheetModal } from '@gorhom/bottom-sheet'

import { color } from '../../theme'
import { ShareSheetContent } from './ShareSheetContent'
import { useMaxWidth } from '../WebWrapper'

const isWeb = Platform.OS === 'web'

export const ShareSheetWeb = forwardRef<BottomSheetModal>((props, ref) => {
  const snapPoints = useMemo(() => ['50%'], [])
  const maxWidth = useMaxWidth()

  if (!isWeb) {
    return null
  }

  return (
    <BottomSheetModal
      name="share-sheet-web"
      ref={ref}
      index={0}
      snapPoints={snapPoints}
      backdropComponent={(props) => <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      overrideReduceMotion={ReduceMotion.System}
      style={{
        marginHorizontal: 'auto',
        maxWidth: maxWidth,
        width: '100%'
      }}
    >
      <ShareSheetContent />
    </BottomSheetModal>
  )
})

const styles = StyleSheet.create({
  bottomSheetHandleStyle: {
    backgroundColor: 'white',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },
  bottomSheetIndicatorStyle: {
    backgroundColor: color.dim,
    height: 2,
    width: 44
  }
})
